/* Standard promotion codes. Browser storage is NOT verified customer identity. */
if (!customElements.get('jessica-pumpkin-demo')) {
  const rewards = {
    three: { value: '−3%', icon: '👻', label: 'BUU! SCHERZETTO · DEMO', title: 'La zucca ride… ma un dolcetto te lo lascia.', text: 'Ti ha fatto prendere un piccolo spavento: ecco il tuo 3% dimostrativo.' },
    five: { value: '−5%', icon: '✦', label: 'FUOCHINO · DEMO', title: 'Fuochino… la magia si accende.', text: 'Ci sei quasi, apprendista strega: il tuo dolcetto dimostrativo è il 5%.' },
    ten: { value: '−10%', icon: '🔥', label: 'FUOCO! · DEMO', title: 'Hai acceso la notte!', text: 'Incantesimo riuscito: hai trovato il dolcetto più grande, il 10% dimostrativo.' }
  };
  customElements.define('jessica-pumpkin-demo', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.scene = this.closest('.bf-pumpkin-game');
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.updateSceneMotion = () => {
        this.scene?.classList.toggle('hw-game-paused', document.hidden || this.motionQuery.matches || Boolean(document.querySelector('bf-motion.static .hero')));
      };
      this.sceneObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        this.scene?.classList.toggle('is-in-view', entries[0].isIntersecting);
      }, { rootMargin: '100px' }) : null;
      if (this.sceneObserver && this.scene) this.sceneObserver.observe(this.scene);
      document.addEventListener('visibilitychange', this.updateSceneMotion);
      document.addEventListener('bf-motion-change', this.updateSceneMotion);
      this.motionQuery.addEventListener('change', this.updateSceneMotion);
      this.updateSceneMotion();
      this.realCoupons = this.dataset.realCoupons === 'true';
      this.codes = { three: this.dataset.codeThree, five: this.dataset.codeFive, ten: this.dataset.codeTen };
      this.storageKey = this.realCoupons ? 'jessica-halloween-coupons-daily-2026' : 'jessica-halloween-demo-daily-2026';
      this.buttons = [...this.querySelectorAll('[data-pumpkin]')];
      this.resetButton = this.querySelector('[data-game-reset]');
      this.resultTitle = this.querySelector('[data-result-title]');
      this.resultText = this.querySelector('[data-result-text]');
      this.resultIcon = this.querySelector('[data-result-icon]');
      this.prize = this.querySelector('[data-game-prize]');
      this.prizeValue = this.querySelector('[data-prize-value]');
      this.prizeLabel = this.querySelector('[data-prize-label]');
      this.resultPanel = this.querySelector('[data-game-result]');
      this.instruction = this.querySelector('[data-game-instruction]');
      this.couponPanel = this.querySelector('[data-game-coupon]');
      this.couponValue = this.querySelector('[data-coupon-value]');
      this.applyCoupon = this.querySelector('[data-apply-coupon]');
      this.copyCoupon = this.querySelector('[data-copy-coupon]');
      this.copyCoupon.addEventListener('click', async () => {
        try { await navigator.clipboard.writeText(this.couponValue.textContent); this.copyCoupon.textContent = 'Codice copiato'; }
        catch (_) { this.copyCoupon.textContent = 'Copia il codice qui sopra'; }
      });
      this.buttons.forEach(button => button.addEventListener('click', () => this.play(button)));
      this.resetButton.addEventListener('click', () => { this.reset(); this.restoreDaily(); });
      this.querySelectorAll('[data-preview-reward]').forEach(control => {
        control.addEventListener('click', () => {
          this.reset(); this.play(this.buttons[1], control.dataset.previewReward);
        });
      });
      if (!this.checkExpired()) this.restoreDaily();
    }
    disconnectedCallback() {
      clearTimeout(this.timer); this.busy = false;
      this.sceneObserver?.disconnect();
      document.removeEventListener('visibilitychange', this.updateSceneMotion);
      document.removeEventListener('bf-motion-change', this.updateSceneMotion);
      this.motionQuery?.removeEventListener('change', this.updateSceneMotion);
    }
    checkExpired() {
      if (!this.realCoupons || Date.now() < Date.parse(this.dataset.campaignEnds)) return false;
      this.buttons.forEach(b => { b.disabled = true; });
      this.completed = true;
      this.couponPanel.hidden = true;
      this.prize.hidden = true;
      this.instruction.textContent = 'PROMOZIONE TERMINATA';
      this.resultTitle.textContent = 'La notte ha chiuso il suo libro di incantesimi.';
      this.resultText.textContent = 'Il gioco e i codici Halloween sono terminati alla fine del 31 ottobre 2026.';
      return true;
    }
    today() {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date());
    }
    readDaily() {
      const raw = localStorage.getItem(this.storageKey);
      if (!raw) return null;
      let saved;
      try { saved = JSON.parse(raw); } catch (_) { return null; }
      return saved && saved.day === this.today() && Object.hasOwn(rewards, saved.reward) &&
        Number.isInteger(saved.index) && saved.index >= 0 && saved.index < 3 ? saved : null;
    }
    restoreDaily() {
      try {
        const saved = this.readDaily();
        if (!saved) return false;
        this.reveal(this.buttons[saved.index], saved.reward, false, true);
        return true;
      } catch (_) { return false; }
    }
    randomReward() {
      const draw = new Uint32Array(1);
      crypto.getRandomValues(draw);
      // Four equally likely quarters: ten, ten, five, three.
      const quarter = draw[0] >>> 30;
      return quarter < 2 ? 'ten' : quarter === 2 ? 'five' : 'three';
    }
    play(button, previewReward = null) {
      if (this.busy || this.completed) return;
      if (!previewReward && this.checkExpired()) return;
      if (!previewReward && this.restoreDaily()) return;
      let reward;
      try {
        reward = previewReward || this.randomReward();
        if (!Object.hasOwn(rewards, reward)) return;
        if (!previewReward) {
          // Persist BEFORE animation so a normal refresh cannot reroll this demo.
          localStorage.setItem(this.storageKey, JSON.stringify({
            day: this.today(), reward, index: this.buttons.indexOf(button)
          }));
        }
      } catch (_) {
        this.resultTitle.textContent = 'Non riusciamo a ricordare la giocata.';
        this.resultText.textContent = 'Consenti il salvataggio locale nel browser per utilizzare il limite giornaliero.';
        return;
      }
      this.busy = true;
      this.buttons.forEach(b => { b.disabled = true; b.classList.toggle('is-muted', b !== button); });
      button.classList.add('is-selected', 'is-opening');
      this.instruction.textContent = 'La notte sta svelando il suo segreto…';
      this.resultTitle.textContent = 'Un piccolo incantesimo è in arrivo…';
      this.resultText.textContent = this.realCoupons && !previewReward ? 'La tua sorpresa è quasi pronta.' : 'Dimostrazione grafica in corso. Nessun premio reale.';
      this.timer = setTimeout(() => {
        if (this.isConnected) this.reveal(button, reward, Boolean(previewReward));
      }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 950);
    }
    reveal(button, reward, previewOnly = false, restored = false) {
      if (!previewOnly && this.checkExpired()) return;
      const outcome = rewards[reward];
      this.buttons.forEach(b => {
        b.disabled = true;
        b.classList.toggle('is-muted', b !== button);
        b.classList.remove('is-opening');
      });
      button.classList.add('is-selected', 'is-revealed', 'is-winner');
      button.dataset.rewardTier = reward;
      this.resultPanel.classList.add('is-winner');
      this.resultPanel.dataset.rewardTier = reward;
      this.prize.hidden = false;
      this.prizeValue.textContent = outcome.value;
      const showCode = this.realCoupons && !previewOnly && Boolean(this.codes[reward]) && !this.checkExpired();
      this.prizeLabel.textContent = showCode ? outcome.label.replace(' · DEMO', '') : outcome.label;
      this.resultIcon.textContent = outcome.icon;
      this.resultTitle.textContent = outcome.title;
      this.resultText.textContent = showCode ?
        outcome.text.replace('dimostrativo', '').replace('dimostrativa', '').replace(/\s+\./g, '.').trim() + ' Usa il codice su un ordine di almeno €10 entro il 31 ottobre. Non cumulabile; ogni codice è utilizzabile una volta per cliente durante la promozione.' :
        outcome.text + ' Nessun codice valido viene emesso.' + (previewOnly ? ' Prova grafica: non cambia la giocata del giorno.' : ' Il risultato resta salvato su questo browser fino a domani, secondo l’ora italiana.');
      this.couponPanel.hidden = !showCode;
      if (showCode) {
        this.couponValue.textContent = this.codes[reward];
        this.applyCoupon.href = this.dataset.discountPrefix + encodeURIComponent(this.codes[reward]) + '?redirect=' + encodeURIComponent(this.dataset.collectionUrl);
      }
      this.instruction.textContent = previewOnly ? 'PROVA GRAFICA · DEMO' :
        restored ? (showCode ? 'IL TUO DOLCETTO DI OGGI' : 'LA TUA GIOCATA DEMO DI OGGI') :
        showCode ? 'DOLCETTO TROVATO · RIPROVA DOMANI' : 'GIOCATA DEMO SALVATA · RIPROVA DOMANI';
      this.busy = false; this.completed = true;
      this.resetButton.hidden = !previewOnly;
    }
    reset() {
      clearTimeout(this.timer);
      this.busy = false; this.completed = false;
      this.buttons.forEach(b => { b.disabled = false; b.classList.remove('is-muted','is-selected','is-opening','is-revealed','is-winner'); });
      this.buttons.forEach(b => { delete b.dataset.rewardTier; });
      this.prize.hidden = true;
      this.couponPanel.hidden = true;
      this.copyCoupon.textContent = 'Copia codice';
      this.resultPanel.classList.remove('is-winner');
      delete this.resultPanel.dataset.rewardTier;
      this.resetButton.hidden = true;
      this.instruction.textContent = 'Scegli la zucca che ti chiama.';
      this.resultTitle.textContent = 'Un tocco, e l’incantesimo comincia.';
      this.resultText.textContent = 'Questa è una prova: nessun premio o codice sconto viene assegnato.';
      this.resultIcon.textContent = '✦';
    }
  });
}
